import { useSelector } from 'react-redux'
import { dataConstants } from 'services/redux/data/constants'
import _ from 'lodash'
import React, { useMemo } from 'react'
import Location from 'scenes/home/book/location/_components/Location'
import HelperCapacityOverview from 'utils/helper-capacity-overview'
import { LocationTypes } from 'utils/constants/location-types';
import VStack from 'components/atoms/stack/VStack'
import { ThemedValues } from 'styles/themed'

const LocationsSceneBlock = ({ depthLevel, locations, building, floor, timeslotKindsForGroup}) => {
	
	const _buildingFavourites = useSelector( state => {
		return state.data[dataConstants.BUILDING_FAVOURITES];
	} );
	const _floorFavourites = useSelector( state => {
		return state.data[dataConstants.FLOOR_FAVOURITES];
	} );
	const _roomFavourites = useSelector( state => {
		return state.data[dataConstants.ROOM_FAVOURITES];
	} );
	
	const capacityKey = HelperCapacityOverview.getCapacityKey( depthLevel );
	
	const favourites = useMemo( () => {
		switch( capacityKey ) {
			case LocationTypes.BUILDINGS:
				return _buildingFavourites;
			
			case LocationTypes.FLOORS:
				return _floorFavourites;
			
			case LocationTypes.ROOMS:
				return _roomFavourites;
		}
	}, [ capacityKey, _buildingFavourites, _floorFavourites, _roomFavourites ] );
	
	const renderLocationProps = {
		locationType: capacityKey,
		timeslotKindsForGroup: timeslotKindsForGroup,
		building: building,
		floor: floor
	}
	
	const renderedLocations = useMemo( () => {
		const result = [];
		
		let index = 0;
		_.forEach( favourites, ( favourite, location_guid ) => {
			const location = _.find( locations, { guid: location_guid } );
			
			if( location !== undefined ) {
				result.push(
					<Location
						key={ `location_${location.guid}` }
						location={ location }
						favourite={ true }
						index={ index }
						{ ...renderLocationProps}
					/>
				)
				
				index++;
			}
		});
		
		_.forEach( locations, location => {
			if( _.get( favourites, location.guid, false ) === false ) {
				result.push(
					<Location
						key={ `location_${location.guid}` }
						location={ location }
						favourite={ false }
						index={index}
						{ ...renderLocationProps}
					/>
				)
				
				index++;
			}
		});
		
		return result;
	}, [ favourites, locations ] );
	
	return (
		<VStack
			space={ ThemedValues.stackSpace }>
			
			{ renderedLocations }
		</VStack>
	);
}

export default LocationsSceneBlock
